import * as React from 'react';

import { DialogDescription } from '@radix-ui/react-dialog';
import { FormattedMessage, useIntl } from 'react-intl';

import { DigitalReceiptCanvas } from 'src/features/payment/components/DigitalReceiptCanvas';
import { paymentsMessages } from 'src/features/payment/utils/messages';
import SquareIcon from 'src/registry/components/blocks/SquareIcon';
import { Button } from 'src/registry/ui/Button';
import {
    Dialog,
    DialogBody,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogSeparator,
    DialogTitle,
} from 'src/registry/ui/Dialog';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';

interface DownloadDigitalReceiptModalProps extends React.HTMLAttributes<HTMLDivElement> {
    digitalReceiptDetails?: string;
    downloadReceipt?: () => void;
}

const DownloadDigitalReceiptModal = ({
    children,
    digitalReceiptDetails,
    downloadReceipt,
}: DownloadDigitalReceiptModalProps) => {
    const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false);
    const { formatMessage } = useIntl();

    return (
        <Dialog open={isModalOpen} onOpenChange={() => setIsModalOpen(!isModalOpen)}>
            {children}
            <DialogContent onOpenAutoFocus={(e) => e.preventDefault()} onCloseAutoFocus={(e) => e.preventDefault()}>
                <DialogHeader>
                    <div className="flex gap-4">
                        <SquareIcon icon={ICON_MAP.RECEIPT} />
                        <div>
                            <DialogTitle>{formatMessage(paymentsMessages.digitalReceipt)}</DialogTitle>
                            <DialogDescription>
                                <FormattedMessage {...paymentsMessages.downloadCopyDescription} />
                            </DialogDescription>
                        </div>
                    </div>
                </DialogHeader>
                <DialogSeparator />
                <DialogBody>
                    <DigitalReceiptCanvas receiptTextLines={digitalReceiptDetails?.split('\n')} />
                </DialogBody>
                <DialogSeparator />
                <DialogFooter className="flex-row">
                    <Button
                        variant="outline"
                        type="button"
                        className="flex-1"
                        onClick={() => setIsModalOpen(!isModalOpen)}
                    >
                        {formatMessage(generalMessages.cancel)}
                    </Button>
                    <Button onClick={downloadReceipt} className="flex-1">
                        <FormattedMessage {...paymentsMessages.downloadReceipt} />
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export { DownloadDigitalReceiptModal };
